import React from 'react';
import { Box, Card, CardContent, CircularProgress, Grid, IconButton, Table, TableBody, TableContainer, TableRow, Tooltip } from "@mui/material";
import { withStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';
import { useEffect } from 'react';
import Helper from '../../utility/helper';
import APIURLConstants from '../../config/config';
import ApiHelper from '../../utility/ApiHelper';
import {
    pdf,
    Document,
    Page,
    Text,
    View,
    Line,
    StyleSheet,
    Svg,
} from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import ExportExcelIcon from '../../sharedcomponents/customIcons/exportExcelIcon';
import { makeStyles } from '@mui/styles';
import { createTheme } from '@mui/material/styles';

const theme = createTheme();

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};
const styles = StyleSheet.create({
    page: {
        display: 'flex',
        // backgroundColor: '#E4E4E4',
    },
    section: {
        margin: 10,
        padding: 10,
        // flexGrow: 1,
    },
    rowView: {
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1px solid #EEE',
        paddingTop: 6,
        paddingBottom: 6,
        textAlign: 'center',
        fontSize: '13px',
    },
    table: {
        width: '100%',
        display: 'flex',
        // flexDirection:''
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1px solid #EEE',
        fontSize: 9,
    },
    header: {
        borderTop: 'none',
        backgroundColor: "#4472c4",
        color: 'white'
    },
    bold: {
        fontWeight: 'bold',
    },
    // So Declarative and unDRY 👌
    teamNameStyle: {
        width: '100%',
        textAlign: 'center',
        backgroundColor: 'black',
        color: 'white',
        fontSize: 10,
        // paddingTop: "5px",
        // paddingBottom: "5px",
    },
    row1: {
        width: '12%',
        paddingLeft: '4px',
        textAlign: 'left',
        // paddingTop: 8,
        // paddingBottom: 8,  
        borderRight: '1px solid black'
    },
    row2: {
        width: '38%',
        textAlign: 'left',
        // paddingTop: 8,
        // paddingBottom: 8, 
        borderRight: '1px solid black',
        marginLeft: '1px'
    },
    row3: {
        width: '40%',
        textAlign: 'left',
        // paddingTop: 8,
        // paddingBottom: 8, 
        borderRight: '1px solid black',
        marginLeft: '1px'
    },
    row4: {
        width: '10%',
        textAlign: 'center',
        // paddingTop: 8,
        // paddingBottom: 8, 
    },
    headerView: {
        display: 'flex',
        flexDirection: 'row',
    },
    left: {
        width: '50%',
        marginRight: '1%',
        marginBottom: '1%'
    },
    right: {
        width: '50%',
        marginLeft: '1%',
        marginBottom: '1%'
    },
    borders: {
        borderLeft: '1px solid black',
        borderRight: '1px solid black',
        borderBottom: '1px solid black',
    },
    headerBorders: {
        border: '1px solid black'
    }

});
const DocumentPdf = (props) => (
    <Document>
        <Page size="A4" orientation="landscape" style={styles.page}>
            <View
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    padding: 10,
                    width: '100%',
                }}>
                <Text
                    style={{
                        fontSize: '18px',
                        color: '#3c5c93',
                        fontWeight: '600',
                        textAlign: 'center',
                        marginBottom: '8px'
                    }}>
                    Rosters Teams
                </Text>
                <Svg height="3" width="100%">
                    <Line
                        x1="0"
                        y1="0"
                        x2="600"
                        y2="0"
                        strokeWidth={5}
                        stroke="rgb(179,169,169)"
                    />
                </Svg>
                {
                    props.team.map((row, i) => {
                        if (row.teamName.trim() !== "") {
                            return (
                                <View key={i} style={styles.row}>
                                    {props.leftTeams.map((rows, k) => {
                                        if (rows.teamName.trim() !== "" && i === k) {
                                            return (
                                                <View key={k} style={[styles.headerView, styles.left]}>
                                                    <View style={[styles.table]}>
                                                        <Text style={styles.teamNameStyle}>{rows.teamName}</Text>
                                                        <View style={[styles.row, styles.bold, styles.header, styles.headerBorders]}>
                                                            <Text style={styles.row1}>Jersey No</Text>
                                                            <Text style={styles.row2}>Name</Text>
                                                            <Text style={styles.row3}>School</Text>
                                                            <Text style={styles.row4}>Pos</Text>
                                                        </View>
                                                        {props.roster.map((tableRow, j) => {
                                                            if (rows.teamName === tableRow.team) {
                                                                return (
                                                                    <View key={j} style={[styles.row, styles.borders]} wrap={false}>
                                                                        <Text style={styles.row1}>
                                                                            <Text style={{ textAlign: 'center' }}>{tableRow.jersey}</Text>
                                                                        </Text>
                                                                        <Text style={styles.row2}>{tableRow.playerName}</Text>
                                                                        <Text style={styles.row3}>{tableRow.collegeOrClub}</Text>
                                                                        <Text style={styles.row4}>
                                                                            <Text style={styles.bold}>{tableRow.positionName}</Text>
                                                                        </Text>
                                                                    </View>
                                                                )
                                                            }
                                                        })
                                                        }
                                                    </View>
                                                </View>
                                            )
                                        }
                                    })}

                                    {props.rightTeams.map((rowss, j) => {
                                        if (rowss.teamName.trim() !== "" && i === j) {
                                            return (
                                                <View key={j} style={[styles.headerView, styles.right]}>
                                                    <View style={[styles.table]}>
                                                        <Text style={styles.teamNameStyle}>{rowss.teamName}</Text>
                                                        <View style={[styles.row, styles.bold, styles.header, styles.headerBorders]}>
                                                            <Text style={styles.row1}>Jersey No</Text>
                                                            <Text style={styles.row2}>Name</Text>
                                                            <Text style={styles.row3}>School</Text>
                                                            <Text style={styles.row4}>Pos</Text>
                                                        </View>
                                                        {props.roster.map((tableRow, j) => {
                                                            if (rowss.teamName === tableRow.team) {
                                                                return (
                                                                    <View key={j} style={[styles.row, styles.borders]} wrap={false}>
                                                                        <Text style={styles.row1}>
                                                                            <Text style={{ textAlign: 'center' }}>{tableRow.jersey}</Text>
                                                                        </Text>
                                                                        <Text style={styles.row2}>{tableRow.playerName}</Text>
                                                                        <Text style={styles.row3}>{tableRow.collegeOrClub}</Text>
                                                                        <Text style={styles.row4}>
                                                                            <Text style={styles.bold}>{tableRow.positionName}</Text>
                                                                        </Text>
                                                                    </View>
                                                                )
                                                            }
                                                        })
                                                        }
                                                    </View>
                                                </View>
                                            )
                                        }
                                    })
                                    }
                                </View>
                            )
                        }
                    })
                }
            </View>
        </Page>
    </Document>
);
const useStyles = makeStyles(() => ({ 
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
    },
     
    paperContent: {
        boxShadow:
            'rgb(145 158 171 / 24%) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 0px 16px 32px -4px',
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
}));
const ShowRosters = () => {
    const [loading, setLoading] = React.useState([]);
    const [teams, setTeams] = React.useState([]);
    const [rosters, setRosters] = React.useState([]);
    const classes = useStyles();

    useEffect(()=>{
        const FetchData = async () => {

        const eventInfo = Helper.getStorage('eventInfo');
        setLoading(true)
        ApiHelper.get(
            APIURLConstants.GET_ROSTER_TEAMS(
                eventInfo.eventID
            )
        )
            .then((res) => {
                if (res.data.value) {
                    setTeams(res.data.value)
                    ApiHelper.get(
                        APIURLConstants.GET_ROSTER_MANAGEMENT(
                            eventInfo.eventID
                        )
                    )
                        .then((res) => {
                            if (res.data.value) {
                                setLoading(false)
                                setRosters(res.data.value)
                            }
                        })

                }
            }).catch((error) => {
                console.log("error", error);
                setLoading(false);
            });
        }
        FetchData();
    }, []);
    const TableHeads = withStyles(() => ({
        root: {
            backgroundColor: "#4472c4"
        }
    }))(TableHead);

    const TableHeaderCell = withStyles(() => ({
        root: {
            color: "white",
            border: '1px solid black'
        }
    }))(TableCell);
    const delay = (t) => new Promise((resolve) => setTimeout(resolve, t));

    const callPdfExport = async () => {

        let leftTeams = []
        let rightTeams = []
        let filtered = teams.filter(function (el) {
            return el.teamName.trim() != "";
        });
        if(filtered.length > 0){
            filtered.map((team, index) => {
                if (index % 2) {
                    rightTeams.push(team)
                } else {
                    leftTeams.push(team)
                }
            })
            const props = {
                team: filtered,
                roster: rosters,
                rightTeams: rightTeams,
                leftTeams: leftTeams
            };
            const doc = <DocumentPdf  {...props} />;
            const asPdf = pdf([]); // {} is important, throws without an argument
            asPdf.updateContainer(doc);
            await delay(3_000);
            const blob = await asPdf.toBlob();
            saveAs(blob, 'roster.pdf');
        } 
    }

    const callExcelExport = () => {
        let data = [];
        if(rosters.length > 0){
            rosters.map((ros) => {
                data.push({
                    JerseyNo: ros.jersey,
                    Name: ros.playerName,
                    Team: ros.team,
                    School: ros.collegeOrClub,
                    Position: ros.positionName,
                })
            })
            const header = {
                JerseyNo: 'JerseyNo',
                Name: 'Name',
                Team: 'Team',
                School: 'School',
                Position: 'Position',
            };
    
            data.unshift(header);
            Helper.downloadReport(data, `roster`);
        }        

    }
    return (
        <>
            <Box className="contentBox" sx={{ flexGrow: 1 }}>
                <Tooltip
                    sx={{ position: 'relative', top: '-56px', left: '270px' }}
                    title="Export PDF"
                    onClick={callPdfExport}
                    aria-label="pdf">
                    <IconButton color="primary">
                        <PictureAsPdfOutlinedIcon
                            fontSize="small"
                            color={'default'}
                        />
                    </IconButton>
                </Tooltip>
                <Tooltip
                    sx={{ position: 'relative', top: '-56px', left: '265px' }}
                    title="Export Excel"
                    onClick={callExcelExport}
                    aria-label="excel">
                    <IconButton color="primary">
                        <ExportExcelIcon
                            fontSize="small"
                            color={'default'}
                        />
                    </IconButton>
                </Tooltip>
                {
                    loading ? (
                        <Box style={loader}>
                            <CircularProgress />
                        </Box>
                    ) :
                        <Grid container spacing={2}>
                            {(teams.length > 0 && rosters.length > 0) ? teams.map((team, i) => {
                                if (team.teamName.trim() !== "") {
                                    return (
                                        <Grid key={i} item xs={6}>
                                            <Box component={'div'} sx={{ backgroundColor: 'black', width: '100%', textAlign: 'center', color: 'white' }}>
                                                <i>{team.teamName}</i>
                                            </Box>
                                            <TableContainer component={Paper}>
                                                <Table size="small" sx={{ minWidth: 500 }} aria-label="simple table">
                                                    <TableHeads>
                                                        <TableRow>
                                                            <TableHeaderCell width="18%">Jersey No</TableHeaderCell>
                                                            <TableHeaderCell width="27%">Name</TableHeaderCell>
                                                            <TableHeaderCell width="35%">School</TableHeaderCell>
                                                            <TableHeaderCell width="20%">Position</TableHeaderCell>
                                                        </TableRow>
                                                    </TableHeads>
                                                    <TableBody>
                                                        {rosters.map((roster, j) => {
                                                            if (roster.team === team.teamName) {
                                                                return (
                                                                    <TableRow key={j} style={{ border: '1px solid' }}>
                                                                        <TableCell style={{ border: '1px solid' }} component="th" scope="row"> {roster.jersey} </TableCell>
                                                                        <TableCell style={{ border: '1px solid' }}>{roster.playerName}</TableCell>
                                                                        <TableCell style={{ border: '1px solid' }}>{roster.collegeOrClub}</TableCell>
                                                                        <TableCell style={{ border: '1px solid' }}>{roster.positionName}</TableCell>
                                                                    </TableRow>
                                                                )
                                                            }
                                                        })}

                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>
                                    )
                                }
                            }) : <Grid item xs={12}>
                                <Card
                                    classes={{ root: classes.paperContent }}
                                    sx={{ width: '100%' }}>
                                    <CardContent
                                        sx={{ p: 2 }}
                                        className={classes.cardContent}>
                                        <Box className={classes.rowContent}>
                                            No data found
                                        </Box>
                                    </CardContent>
                                </Card></Grid>}
                        </Grid>}
            </Box>
        </>
    )
}

export default ShowRosters;
